const constants = {
  TAB_RESOURCE_ALLOCATION: 'Asignación de recursos',
  TAB_GENERAL_DATA: 'Datos generales',
  TAB_FINANCIAL_CONDITIONS: 'Condiciones financieras',
  TAB_CHARGES: 'Cargos',
  TAB_TRANSFERS: 'Transferencias',
  TAB_CONTRACT_LIQUIDATION: 'Liquidación de contrato',
  TAB_COVERAGE: 'Coberturas',
  TAB_CONSOLIDATION_TRANSFERS: 'Consolidar transferencias',
  TAB_RESERVE_OF_FUNDS: 'Reserva de fondos',
  OPTIONAL_LABEL: 'No obligatoria',
}
export default constants
